import React from "react";

function Check() {
    return (
        <svg width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg">
           <path d="M11.5745 0.106383C11.7163 -0.035461 11.9433 -0.035461 12.0567 0.106383L12.8794 0.900709C12.9929 1.04255 12.9929 1.2695 12.8794 1.38298L4.36879 9.89362C4.22695 10.0355 4.02837 10.0355 3.88652 9.89362L0.0851064 6.12057C-0.0283688 5.97872 -0.0283688 5.75177 0.0851064 5.6383L0.907801 4.8156C1.02128 4.70213 1.24823 4.70213 1.39007 4.8156L4.11347 7.56738L11.5745 0.106383Z" fill="black"/>
        </svg>
    )
}

export default Check;